import MainPage from 'navigation/pages/MainPage';
import modulesMap from 'core/modulesMap';
import PageHeader from 'components/page-header/PageHeader';
import Pagination from 'components/pagination/Pagination';
import { extractInfoFromXhr } from 'navigation/page-manager/CustomPageManager';
import { forceArray } from 'navigation/component/Component';
import { updatePageLinks } from 'core/router';
import browser from 'helpers/browser';
import { findMostPopularNumber } from 'sections/category/partials/CategoryProducts';
import { bindEmitterMethod } from 'helpers/bind';
import Footer from 'components/footer/Footer';
class Journal extends MainPage {
    loading = false;
    endpoint;
    io;
    visibleEntries = [];
    currentPage = 1;
    getModulesMap() {
        return {
            ...modulesMap,
            pageHeader: ['.page-header', PageHeader],
            pagination: ['.pagination', Pagination],
            footer: ['footer', Footer]
        };
    }
    initialized() {
        super.initialized();
        this.endpoint = this.refs.journalList?.getAttribute('data-src') || '';
        this.io = new IntersectionObserver(this.watchPageScrollChange.bind(this), { threshold: [1] });
        if (this.refs.editorialItem) {
            for (let i = 0; i < this.refs.editorialItem.length; i++)
                this.io.observe(this.refs.editorialItem[i]);
        }
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            seen: Array.from(this.el.querySelectorAll('.editorial__list a'))?.length,
            pages: this.refs.journalList?.getAttribute('data-nb-pages') || 0,
            current: this.refs.journalList?.getAttribute('data-page') || 0
        };
    }
    bindEvents(add) {
        const emitterMethod = bindEmitterMethod(add);
        forceArray(this.modules.pagination || []).forEach(p => {
            p[emitterMethod]('load', (page, direction) => this.loadNewPage(page, direction));
        });
    }
    watchPageScrollChange(entries) {
        for (let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
                this.visibleEntries.push(entries[i].target);
            }
            else {
                const index = this.visibleEntries.indexOf(entries[i].target);
                if (index > -1)
                    this.visibleEntries.splice(index, 1);
            }
        }
        // determine the current page by getting the most popular page in data-page on visible products
        const pages = this.visibleEntries.map(p => p.getAttribute('data-page'));
        // in the pages array, determine which values is the most present and output it
        if (pages.length) {
            const current = findMostPopularNumber(pages);
            if (current !== this.currentPage) {
                this.currentPage = current;
                if (this.currentPage > 1)
                    window.history.replaceState({}, '', this.endpoint + (~this.endpoint.indexOf('?') ? '&' : '?') + 'page=' + this.currentPage);
                else
                    window.history.replaceState({}, '', this.endpoint);
            }
        }
    }
    loadNewPage(page, direction = 1) {
        if (this.loading)
            return;
        this.loading = true;
        this.pageManager.state.loading = true;
        const link = this.endpoint + (~this.endpoint.indexOf('?') ? '&' : '?') + 'page=' + page;
        if (link) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest();
                xhr.withCredentials = true;
                xhr.responseType = 'document';
                xhr.open('GET', link, true);
                xhr.setRequestHeader('X-Fursac-Async', 'true');
                xhr.onload = (event) => {
                    window.history.pushState({}, '', link);
                    this.onPageLoaded(event, page, direction);
                    resolve();
                };
                xhr.send();
            });
        }
        else {
            return new Promise(resolve => {
                console.warn('No endpoint set to load new page'); // eslint-disable-line
                resolve();
            });
        }
    }
    onPageLoaded = ({ currentTarget: xhr }, pageIndex, direction) => {
        this.loading = false;
        this.pageManager.state.loading = false;
        const page = xhr.response;
        extractInfoFromXhr(xhr);
        xhr.onload = null;
        const items = Array.from(page.querySelectorAll('.editorial__list .editorial__item'));
        if (direction === 1)
            this.refs.journalList.append(...items);
        else
            this.refs.journalList.prepend(...items);
        // this.el.querySelector('.pagination.next').outerHTML = page.querySelector('.pagination.next').outerHTML
        this.refs.loadMore?.setAttribute('href', page.querySelector('.pagination.next a')?.getAttribute('href'));
        if (page.querySelector('.pagination.prev a'))
            this.refs.loadLess?.setAttribute('href', page.querySelector('.pagination.prev a')?.getAttribute('href'));
        forceArray(this.modules.pagination).forEach(p => {
            p.onPageLoaded(pageIndex, items.length, direction);
        });
        this.modules.revealList.reset();
        updatePageLinks();
        browser.waitRepaint(() => {
            this.refresh();
            this.io.disconnect();
            for (let i = 0; i < this.refs.editorialItem.length; i++)
                this.io.observe(this.refs.editorialItem[i]);
        });
    };
}
export default Journal;
